import { render, staticRenderFns } from "./NumberedList.vue?vue&type=template&id=3db9c798&"
import script from "./NumberedList.vue?vue&type=script&lang=js&"
export * from "./NumberedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageColumnNumberedListInner: require('/usr/src/motec/components/page/column/NumberedListInner.vue').default})
